import type { VisibilityRuleSet } from '@/store/consultation.interface';

/**
 * The questions a visitor who is not logged in does not see in a guided consultation: every question shown on a
 * condition. Such a visitor has answered nothing, and the API hides a question from a participant who has not
 * answered its source yet.
 */
export function hiddenFromVisitors(ruleSets: VisibilityRuleSet[] | undefined): Set<number> {
  return new Set((ruleSets ?? []).filter(({ conditions }) => conditions.length > 0).map(({ targetId }) => targetId));
}
